/* prevent skipping through form with Enter key */
/* don't restrict textarea, allow line breaks */
$(document).on("keyup keypress", "#form_ecosizer input", function (e) {
	var keyCode = e.keyCode || e.which;
	if (keyCode === 13) {
		e.preventDefault();
		e.stopPropagation();
		//trigger defocus of currently focused element
		$(':focus').blur();
		return false;
	}
});

/* remove error class when user starts typing */
// $('input[type=text], input[type=email], input[type=tel]').on('input', function () {
// 	$(this).parents('.field-wrap').removeClass("error");
// });

/* show style change to input label */
$(document).on("focus", "#form_ecosizer input", function () {
	const fieldWrap = $(this).parents('.field-wrap');

	/* check for error or warning class and open Help Panel */
	/* don't open help panel for JS errors */
	//if ($(fieldWrap).is('.error, .warning') && !$(fieldWrap).hasClass('js-error')) {
	if ($(fieldWrap).is('.error, .js-error, .warning')) {
		openHelpPanel('inputs', $(this).attr('name'), $(this));
	}

	/* remove error message from markup */
	//$('ul.errorlist', fieldWrap).remove();
	//$(fieldWrap).addClass('focused').removeClass('error js-error warning warning-expmin warning-expmax');
	$(fieldWrap).addClass('focused').removeClass('js-error warning warning-expmin warning-expmax');
});

$(document).on("blur", "#form_ecosizer input", function () {
	$(this).parents('.field-wrap').removeClass('focused');

	/* close open panels */
	$('.help-panel').remove();

	if ($(this).attr('type') === 'number') {
		checkMinMax(this);
	}

	/* Recirculation Loop fields */
	/* if any of these fields receive input, run the calculation */
	const loopFields = ['recircFlow', 'recircTemp', 'nApt', 'nBR0', 'nBR1', 'nBR2', 'nBR3', 'nBR4', 'nBR5'];
	if (loopFields.includes($(this).attr('name'))) {
		calculateRLHL();
	}

	/* if we have hidden water sliders to calculate sum */
	if ($('#fieldgroup-RPep').hasClass('ca_mode')) {
		const bedroomFields = ['nBR0', 'nBR1', 'nBR2', 'nBR3', 'nBR4', 'nBR5'];
		if (bedroomFields.includes($(this).attr('name'))) {
			fetchGPDPP();
		}
	}
});

/* prevent mouse scrollwheel from changing values in number inputs */
$(':input[type=number]').on('mousewheel', function (e) {
	e.preventDefault();
});

/* btn to process form */
// $(document).on("click", "button[type=submit]", function (e) {
// 	e.preventDefault();
// 	e.stopPropagation();
// 	this_form = $(this).parents('form')[0];
// 	validateForm(this_form);
// });

$(document).on("click", ".js-btn-toggle", function (e) {
	$(this).blur();
});

$(document).on("click", "button#toggle-RLHLmethod", function (e) {
	e.preventDefault();
	e.stopPropagation();
	toggleRLHLmethod();
});

$(document).on("click", "button#toggle-loadshift", function (e) {
	e.preventDefault();
	e.stopPropagation();
	toggleLoadshift();
});

$(document).on("click", ".meta-loadshift .js-btn-toggle", function (e) {
	e.preventDefault();
	e.stopPropagation();
	const target = $(this).attr('data-target');

	if ($(this).hasClass('toggled')) {
		disableLoadShiftPeriod(target);
	} else {
		enableLoadShiftPeriod(target);
	}
});

$(document).on("click", "button#toggle-ca_spec", function (e) {
	e.preventDefault();
	e.stopPropagation();
	CA_spec_mode();
});

$(document).on("click", "button#toggle-ca_bedroom", function (e) {
	e.preventDefault();
	e.stopPropagation();
	userGPDBR("ca"); //consecutively calls toggleCA_Bedroom();
});

$(document).on("click", "#fs-inputmethod .js-btn-option", function (e) {
	e.preventDefault();
	e.stopPropagation();
	let data_value = $(this).attr('data-value');
	toggleInputMethod(data_value);
});

$(document).on("click", ".js-adv-options", function (e) {
	e.preventDefault();
	e.stopPropagation();
	$(this).blur();
	$(this).toggleClass("toggled");
	let parent = $(this).parents('.advanced-options');
	$(parent).toggleClass("expanded");
});

$(document).on("click", ".js-btn-expand", function (e) {
	e.preventDefault();
	e.stopPropagation();
	$(this).blur();
	$(this).toggleClass("toggled");

	$(this).parents('.section-expandable').toggleClass("collapsed");
});

$(document).on("click", ".js-schematic-btn", function (e) {
	e.preventDefault();
	e.stopPropagation();
	const data_value = $(this).attr('data-value');
	setupSchematic(data_value);
	if (data_value === "swingtank") {
		if ($("#swingtankelement").hasClass('d-none')) {
			$("#swingtankelement").removeClass("d-none");
		}
	} else {
		$("#swingtankelement").addClass('d-none');
	}
	if (data_value === "swingtank" || data_value === "paralleltank") {
		if ($('#tempmaintstoragevol').hasClass('d-none')) {
			$('#tempmaintstoragevol').removeClass('d-none');
		}
	}else {
		$('#tempmaintstoragevol').addClass('d-none');
	}
	if (data_value === "paralleltank") {
		$("#parallelHpwh").removeClass('d-none');
		$("#numheatpumps").removeClass('d-none');
	} else {
		$("#parallelHpwh").addClass('d-none');
		$("#numheatpumps").addClass('d-none');
	}

	// Multi Pass - Return to Primary: lock Normal loadshift fields and Building Type
	const mprtpFields = ['aquastatFraction', 'lsNorm_TempSetOnTrig', 'lsNorm_TempSetOffTrig', 'storageT', 'offSensor_normal'];
	// Default values for mprtp Normal row
	const mprtpDefaults = {
		'aquastatFraction': 40,
		'lsNorm_TempSetOnTrig': 115,
		'lsNorm_TempSetOffTrig': 140,
		'storageT': 150,
		'offSensor_normal': 35
	};

	if (data_value === "mprtp") {
		// Set Normal loadshift fields to mprtp defaults and lock them
		Object.keys(mprtpDefaults).forEach(function(fieldName) {
			const field = $(`input[name="${fieldName}"]`);
			if (field.length) {
				field.val(mprtpDefaults[fieldName]);
				field.prop('readonly', true).attr('tabindex', '-1');
				field.parents('.field-wrap').addClass('locked').removeClass('js-error warning warning-expmin warning-expmax');
			}
		});

		// Lock Building Type to Multifamily
		const bldChoice = $('#bld-choice');
		const prevBuildingType = bldChoice.val();
		if (prevBuildingType !== 'multi_family') {
			bldChoice.val('multi_family');
			updateOccupancyField('multi_family', prevBuildingType);
		}
		bldChoice.prop('disabled', true);
		bldChoice.parents('.field-wrap').addClass('locked');
	} else {
		// Unlock fields when switching away from mprtp
		mprtpFields.forEach(function(fieldName) {
			const field = $(`input[name="${fieldName}"]`);
			if (field.length) {
				field.prop('readonly', false).attr('tabindex', '');
				field.parents('.field-wrap').removeClass('locked');
			}
		});

		// Unlock Building Type
		$('#bld-choice').prop('disabled', false);
		$('#bld-choice').parents('.field-wrap').removeClass('locked');
	}

	// if (data_value === "single_pass") {
	// 	$("#mploadshift").addClass('d-none');
	// 	$("#sploadshift").removeClass('d-none');
	// } else if (data_value === "multi_pass") {
	// 	$("#sploadshift").addClass('d-none');
	// 	$("#mploadshift").removeClass('d-none');
	// }
});

async function updateOccupancyField(newval, oldval) {

	const buildingIDs = {
		"multi_family": "nPeople",
		"mens_dorm": "nMensDorm",
		"womens_dorm": "nWomensDorm",
		"motel": "nMotel",
		"elementary_school": "nElemSchool",
		"junior_high": "nJrHigh",
		"senior_high": "nSrHigh",
		"nursing_home": "nNursingHome",
		"food_service_a": "nFoodSvcA",
		"food_service_b": "nFoodSvcB",
		"office_building": "nOffice",
		"apartment": "nAptAsh",
	}
	// if its null, nothing to hide, on page init.
	if (oldval) {
		const oldgroupID = "#grp_"+buildingIDs[oldval];
		$(oldgroupID).addClass('d-none');
	}
	const newgroupID = "#grp_"+buildingIDs[newval];
	$(newgroupID).removeClass('d-none');
	// const inputField = $('input[name="nPeople"]', '#form_ecosizer')[0];
	// const inputID = $(inputField).attr('id');
	// const fieldWrap = $(inputField).parents('.field-wrap')[0];
	// let label = $('label', fieldWrap).html();
	// $('label', fieldWrap).html(newLabel).attr("for", inputID);
	while(!jsonData){
		await new Promise(resolve => setTimeout(resolve, 150));
	}
	$('#bld_desc').html(jsonData['inputs']['buildingType']['value_desc'][newval]);

	if (newval === "multi_family") {
		$(newgroupID).parent().removeClass('col-3');
		$(newgroupID).parent().addClass('col-2');
		if ($('#fs-CAspec').hasClass("disabled")) {
			$('#fs-CAspec').removeClass("disabled")
		}
		if ($('#nApts,#nGals').hasClass("d-none")){
			$('#nApts,#nGals').removeClass("d-none");
		}
		if ($("#fs-inputmethod").find(".btn-group").hasClass("d-none")){
			$("#fs-inputmethod").find(".btn-group").removeClass("d-none")
		}
		if($("#fieldgroup-NPep-multi_family").find(".icon").hasClass("d-none")) {
			$("#fieldgroup-NPep-multi_family").find(".icon").removeClass("d-none")
		}

		$('#toggle-loadshift').removeClass("locked");
		$('#ls_warn_disabled').addClass('d-none');
		$('h2:contains("Load Shift")').addClass('color-blue');
	} else {
		$(newgroupID).parent().removeClass('col-2');
		$(newgroupID).parent().addClass('col-3');
		if (!$('#fs-CAspec').hasClass("disabled")) {
			$('#fs-CAspec').addClass("disabled")
		}
		if (!$('#nApts,#nGals').hasClass("d-none")){
			$('#nApts,#nGals').addClass("d-none");
		}
		if (!$("#fs-inputmethod").find(".btn-group").hasClass("d-none")){
			$("#fs-inputmethod").find(".btn-group").addClass("d-none")
		}
		if(!$("#fieldgroup-NPep-multi_family").find(".icon").hasClass("d-none")) {
			$("#fieldgroup-NPep-multi_family").find(".icon").addClass("d-none")
		}

		if (!$('#advSchemOpt').hasClass('toggled')) {
			$('#advSchemOpt').toggleClass('toggled');
		}
		if (!$('#advSchemOpt').parents('.advanced-options').hasClass('expanded')){
			$('#advSchemOpt').parents('.advanced-options').toggleClass('expanded');
		}
		if (!$('#toggle-RLHLmethod').hasClass('toggled')){
			toggleRLHLmethod(true);
			$("#fields-RLHLmethod .js-btn-toggle").addClass("locked");
		} else {
			$("#fields-RLHLmethod .js-btn-toggle").addClass("locked");
		}

		if ($('#toggle-loadshift').hasClass('toggled')){
			toggleLoadshift();
			$('#toggle-loadshift').addClass("locked");
		} else {
			$('#toggle-loadshift').addClass("locked");
		}
		if ($('#id_inputmethod').val() === "RPep"){
			// Then we hide the RPep div
			toggleInputMethod('NPep');
			// if(!$('#fieldgroup-RPep').hasClass('closed')) {
			// 	$('#fieldgroup-RPep').addClass('closed');
			// }
		}
		$('#ls_warn_disabled').removeClass('d-none');
		$('h2:contains("Load Shift")').removeClass('color-blue');
	}
}

// On document load initialize previous value for building choice selector
$(function () {
	bldChoice = $('#bld-choice');
	bldChoice.data('previous', bldChoice.val());
	// send null since there isn't a previous val.
	updateOccupancyField(bldChoice.val(), null);
});

$(document).on("focus", "#bld-choice", function () {
	$(this).data('previous', $(this).val());
})

$(document).on("change", "#bld-choice", function (e) {
	// e.preventDefault(); not sure if needed
	// e.stopPropagation(); not sure if needed
	updateOccupancyField($(this).val(), $(this).data('previous'));
	$(this).data('previous', $(this).val());
	$(this).trigger('blur');

});

$(document).on('blur', '[name=storageT]', function() {
	$('[name=storageT').val($(this).val());
	$("[name='lsNorm_TempSetOffTrig'], [name='lsLoadUp_TempSetOffTrig'], [name='lsShed_TempSetOffTrig']").val($(this).val() -10);
	$("[name='lsShed_TempSetHPWHOut']").val($(this).val());
	var storageTVal = parseFloat($(this).val());
	var currentLoadUpOut = parseFloat($("[name='lsLoadUp_TempSetHPWHOut']").val());
	if (storageTVal > currentLoadUpOut) {
		$("[name='lsLoadUp_TempSetHPWHOut']").val(storageTVal);
	}
});

$(function () {
	url = window.location.pathname;
	if (url === "/sizer/size/" ){
		$("[name='lsNorm_TempSetOffTrig'], [name='lsLoadUp_TempSetOffTrig'], [name='lsShed_TempSetOffTrig']").val(Math.trunc($('[name=storageT').val() -10));
		$("[name='lsShed_TempSetHPWHOut']").val(Math.trunc($('[name=storageT').val()));
	}
})

$(document).on('blur', '[name=aquastatFraction]', function() {
	$('[name=aquastatFraction').val($(this).val())
});

$(document).on("click", ".slider-water .preset", function (e) {
	const sliderID = $(this).parents('.slider-water').attr('id');
	const slider = document.getElementById(sliderID);
	const value = $(this).attr('data-value');
	slider.noUiSlider.set(value);
});

$(document).on("click", "[data-jump]", function (e) {
	e.preventDefault();
	e.stopPropagation();
	const tag = $(this).attr('data-jump');
	const element = '#' + tag;
	jumpTo(element);
});

/* use mouse down to trigger before input blur event */
$(document).on("mousedown", "[data-help]", function (e) {
	e.preventDefault();
	e.stopPropagation();
	e.stopImmediatePropagation();

	/* keyName, fieldName */
	/* e.g. inputs-swingtank */
	const target = $(this).attr('data-help').split('-');
	openHelpPanel(target[0], target[1], $(this));
	return false; //prevent click event
});

/* prevent form submission when mousedown propagates to click event */
$(document).on("click", "[data-help]", function (e) {
	e.preventDefault();
	e.stopPropagation();
	e.stopImmediatePropagation();
	return false; //prevent click event
});

$(document).on("click", ".radio-group .btn-radio", function (e) {
	e.preventDefault();
	e.stopPropagation();
	radioGroup(this);
});
